import React from "react";

import { Box } from "@mui/material";

const ServiceCard = ({ title, children, ...props }) => (
  <Box
    sx={{
      borderRadius: "4px",
      borderLeft: "24px solid #2d2f2c",
      borderRight: "24px solid #2d2f2c",
      borderBottom: "12px solid #2d2f2c",
      borderTop: "12px solid #2d2f2c",
      pl: { xs: 2, sm: 8 },
      position: "relative",
      pr: { xs: 2, sm: 4 },
      py: 4,
      "&::before": {
        content: '""',
        backgroundImage: "url(/static/cards/service-card/decor-top.png)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        display: "block",
        height: "48px",
        left: "50%",
        position: "absolute",
        top: 4,
        transform: "translate(-50%, -50%)",
        width: "150px",
        zIndex: 1,
      },
    }}
    {...props}
  >
    <Box
      sx={{
        display: { xs: "none", sm: "block" },
        backgroundColor: "primary.main",
        position: "absolute",
        left: "16px",
        top: 0,
        width: 16,
        height: "100%",
      }}
    />
    {children}
  </Box>
);

export default ServiceCard;
